<template>
  <!-- <transition name="fold-left"> -->
      <router-view></router-view>
  <!-- </transition> -->
</template>

<script>
import config from '@/assets/js/config'
export default {
  name: 'App',
  components: {
    
  },
  mounted(){
	if(config.anonymousAuth){
		document.body.style.backgroundColor = 'rgb(255, 255, 255)'; 
	}else{
		var userAgent = navigator.userAgent;
		if (/miniProgram/i.test(userAgent) && /micromessenger/i.test(userAgent)&&window.miniImsp) {
			document.body.style.backgroundColor = window.miniImsp.color;
			this.$store.dispatch('mqtt/sendTopics');
		}else{
			let color=window.android.getThemeBackColor();
			document.body.style.backgroundColor = color; 
		}
		
	}
  }
}
</script>

<style scoped>
.fold-left-enter-active {
    animation-name: fold-left-in;
    animation-duration: .3s;
  }
  /* .fold-left-leave-active {
    animation-name: fold-left-out;
    animation-duration: .3s;
  } */
  @keyframes fold-left-in {
    0% {
      -webkit-transform: translate3d(0, 100%, 0);
      transform: translate3d(0, 100%, 0);

    }
    100% {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
  }
  @keyframes fold-left-out {
    0% {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
    100% {
      -webkit-transform: translate3d(0, -100%, 0);
      transform: translate3d(0, -100%, 0);
    }
  }


</style>